itsoftApp.createModule("adding", function () {
    var module = this;
    var addingButtons = document.querySelectorAll(".js-adding-button");

    var onAddingButtonClick = function (evt) {
        evt.preventDefault();
        var button = evt.currentTarget;
        var toggleText = button.getAttribute("data-toggle-text");
        var dataAddingContainers = document.querySelectorAll("[data-adding-container='" + button.getAttribute('data-adding-name') + "']");
        var anchor = button.getAttribute("data-anchor");
        if (anchor) {
            var anchorTarget = document.querySelector(anchor);
        }
        var oldText;

        if (toggleText) {
            oldText = button.textContent;
            button.textContent = toggleText;
            button.setAttribute("data-toggle-text", oldText);
            button.classList.toggle("js-toggle");
        }

        if (dataAddingContainers.length > 0) {
            Array.prototype.forEach.call(dataAddingContainers, function (container) {
                container.classList.toggle("js-adding-toggle");
            });
        }

        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                if (anchor && !button.classList.contains("js-toggle")) {
                    itsoftApp.modules.animateScroll.callback(anchorTarget);
                }
            });
        });
    };

    if (addingButtons.length > 0) {
        Array.prototype.forEach.call(addingButtons, function (addingButton) {
            addingButton.addEventListener("click", onAddingButtonClick);
        });
    }
});